import logo from "../../img/autoagendamientov2/ike_R_Blanco.svg";
import logoKomCare from "../../img/autoagendamientov2/komcare.svg";
export default function HeaderTop({ company = null }) {
  return (
    <div className={`d-flex bg-level1 ${company?.id === 1 ? "py-4 " : "py-0"}`}>
      <div className="pl-4">
        {company?.id === 1 && <img src={logo} alt="Ike" width={60} />}
        {company?.id === 2 && <img src={logoKomCare} alt="Ike" width={120} />}
      </div>
    </div>
  );
}
